export default __webpack_public_path__ + "static/media/feed2.abc5822f.jpg";